import { gql } from '@apollo/client';

export const READ_CHARGING_SESSIONS = gql`
  query readHistoryChargingSessionsV2(
    $input: ReadHistoryChargingSessionsInputV2
  ) {
    readHistoryChargingSessionsV2(input: $input) {
      totalPages
      last
      number
      content {
        countryCode
        startTime
        endTime
        paymentState
        cardId
        parkingZoneUid
        priceInCents
        created
        chargingSessionId
        parkZone {
          uid
          name
          address {
            marker
          }
          commercialZoneView {
            name
          }
          locationType
        }
      }
    }
  }
`;
